__turbopack_context__.v({
  "filterTable": "filtertable-module-scss-module__NWokLG__filterTable",
});
